@if (Error) {
  <mj-empty-state Variant="error" Title="Couldn't load program status" [Message]="Error"><div actions><button type="button" mjButton variant="primary" (click)="Refresh()">Try again</button></div></mj-empty-state>
} @else if (NoSeason) {
  <mj-empty-state Variant="empty" Title="OEP is between seasons" Message="There is no active OEP season yet. We will email you when your role opens." />
} @else if (!Loading || Gates.length > 0) {
<section class="oep-ps" [attr.aria-busy]="Busy || Loading">
  <!-- markup.html:844-845 -->
  <h1 class="oep-ps__h1">Program status</h1>
  <p class="oep-ps__sub">{{ SeasonCode }} · every number here exports to CSV.</p>

  <!-- markup.html:847-855 staffStats (logic.js:736-741) -->
  <ul class="oep-ps__stats">
    @for (s of Stats; track s.Label) {
      <li class="oep-ps__tile">
        <span class="oep-ps__tile-label">{{ s.Label }}</span>
        <mj-stat-badge class="oep-ps__stat" [Count]="s.Value" [Label]="s.Note" />
      </li>
    }
  </ul>

  <p class="oep-ps__status" role="status" aria-live="polite" [attr.data-tone]="Status?.Tone">{{ Status?.Text }}</p>

  <!-- markup.html:857-872 opsActions (logic.js:619-631; rows are OEP_GATES) -->
  <div class="oep-ps__panel">
    <h2 class="oep-ps__h2">Run the season</h2>
    <p class="oep-ps__lead">Every gate in the timeline, in the order it happens. Each one logs who ran it and when.</p>
    <ol class="oep-ps__gates">
      @for (g of Gates; track g.Key) {
        <li class="oep-ps__gate">
          <span class="oep-ps__when">{{ g.When }}</span>
          <span class="oep-ps__gate-text">
            <span class="oep-ps__gate-title" [id]="'oep-ps-g-' + g.Key">{{ g.Title }}</span>
            <span class="oep-ps__gate-note">{{ g.Note }}</span>
          </span>
          @if (g.State === 'done') {
            <button type="button" class="oep-ps__done" disabled [attr.aria-describedby]="'oep-ps-g-' + g.Key">{{ g.Label }}</button>
          } @else {
            <button type="button" mjButton variant="outline" class="oep-ps__run" [disabled]="!g.Enabled || Busy" [attr.aria-describedby]="'oep-ps-g-' + g.Key" (click)="RunGate(g)">{{ g.Label }}</button>
          }
        </li>
      }
    </ol>
  </div>

  <!-- markup.html:874-895 By section (logic.js:742-763) -->
  <div class="oep-ps__panel oep-ps__panel--flush">
    <div class="oep-ps__bar">
      <h2 class="oep-ps__h2" id="oep-ps-sections">By section</h2>
      <div class="oep-ps__buttons">
        <button type="button" mjButton variant="primary" [disabled]="RemindersDisabled" (click)="SendReminders()">{{ ReminderLabel }}</button>
        <button type="button" mjButton variant="outline" [disabled]="TrainingDisabled" (click)="SendTraining()">{{ TrainingLabel }}</button>
        <button type="button" mjButton variant="outline" (click)="OpenEmails.emit()">Email templates</button>
        <button type="button" mjButton variant="outline" [disabled]="Busy" (click)="ExportCsv()">Export CSV</button>
      </div>
    </div>
    @if (Sections.length === 0) {
      <p class="oep-ps__empty">No sections have presentations or a committee yet.</p>
    } @else {
      <!-- Explicit roles keep table semantics when the phone layout stacks rows (display: grid drops them in some browsers). -->
      <table class="oep-ps__table" role="table" aria-labelledby="oep-ps-sections">
        <thead role="rowgroup">
          <tr role="row">
            <th scope="col" role="columnheader">Section</th>
            <th scope="col" role="columnheader">Drafts</th>
            <th scope="col" role="columnheader">Reviews</th>
            <th scope="col" role="columnheader">Nominations</th>
            <th scope="col" role="columnheader">Winners</th>
          </tr>
        </thead>
        <tbody role="rowgroup">
          @for (r of Sections; track r.SectionID) {
            <tr role="row">
              <th scope="row" role="rowheader" class="oep-ps__name">{{ r.Name }}</th>
              <td role="cell"><span class="oep-ps__label" aria-hidden="true">Drafts</span>{{ r.Drafts }}</td>
              <td role="cell"><span class="oep-ps__label" aria-hidden="true">Reviews</span>{{ r.Reviews }}</td>
              <td role="cell"><span class="oep-ps__label" aria-hidden="true">Nominations</span>{{ r.Nominations }}</td>
              <td role="cell" class="oep-ps__winners">
                <span class="oep-ps__label" aria-hidden="true">Winners</span>
                <span class="oep-badge" [attr.data-tone]="r.Winners.Tone">{{ r.Winners.Label }}</span>
                @if (r.ReopenID !== null) {
                  <button type="button" class="oep-ps__reopen" [disabled]="Busy" [attr.aria-label]="'Reopen ' + r.Name + ' winners'" (click)="Reopen(r)">Reopen</button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>

  <!-- markup.html:897-904 (computed, not the prototype's static list) -->
  <div class="oep-ps__nudge">
    <h2 class="oep-ps__nudge-title">Needs a nudge</h2>
    @if (NudgeLines.length === 0) {
      <p class="oep-ps__nudge-none">{{ NoNudge }}</p>
    } @else {
      <ul class="oep-ps__nudge-list">
        @for (n of NudgeLines; track $index) { <li>{{ n }}</li> }
      </ul>
    }
  </div>
</section>
} @else {
  <mj-empty-state Variant="empty" Icon="fa-solid fa-spinner" Title="Loading program status" Message="Fetching the season's numbers…" />
}
